import { layoutWithLines, prepareWithSegments } from "@chenglou/pretext";
import { Box, Text } from "@chakra-ui/react";
import { React, startTransition, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

// All around the Restaurant people and things relaxed and chatted. The air was filled with talk of this and that, and with the mingled scents of exotic plants, extravagant foods and insidious wines. For an infinite number of miles in every direction the universal cataclysm was gathering to a stupefying climax. Glancing at his watch. Max returned to the stage with a flourish.
// "And now, ladies and gentlemen," he beamed, "is everyone having one last wonderful time?"
// "Yes," called out the sort of people who call out "yes" when comedians ask them if they're having a wonderful time.
// "That's wonderful," enthused Max, "absolutely wonderful. And as the photon storms gather in swirling crowds around us, preparing to tear apart the last of the red hot suns, I know you're all going to settle back and enjoy with me what I know we will find all an immensely exciting and terminal experience."
// He paused. He caught the audience with a glittering eye.
// "Believe me, ladies and gentlemen," he said, "there's nothing penultimate about this one."
// He paused again. Tonight his timing was immaculate. Time after time he had done this show, night after night. Not that the word night had any meaning here at the extremity of time. All there was the endless repetition of the final moment, as the Restaurant rocked slowly forward over the brink of time's furthest edge - and back again. This "night" was good though, the audience was writhing in the palm of his sickly hand. His voice dropped. They had to strain to hear him.
// "This," he said, "really is the absolute end, the final chilling desolation, in which the whole majestic sweep of creation becomes extinct. This ladies and gentlemen is the proverbial 'it'."
// He dropped his voice still lower. In the stillness, a fly would not have dared clear its throat.
// "After this," he said, "there is nothing. Void. Emptiness. Oblivion. Absolute nothing..."

const originalText = "6#:?[@<-:/DIal3BOr;aATMs%F`Lo.F<GO6DfBN(+CT.u+EV:2DJ+#5Eb0&qG\\(D.@;]Tu@q]:mFCeu8+B3#c+CSu)+Eq78+D,>(Ch7-\"GA2/4+EV%.CERP-+EV:2F!+n/A0>u-@<=%C@;]TuGA2/4+EV:.+Dkh1B5D-i+EM%(DKKqBDe:,'G].\\<@j#`,@;^1./0JMKFE1f5@:s\"dF<G16De*o3@;]TuBl8!+A8,t)F!,[@DImlA+@^9i+CT.1Bl7NsDJ=3(+Du==@V'R&De:,/Bl%@%+DG^9AThX*Gp$X3Eb/a&Bl@l3FD,5.F`(o:ATDj#C`m4rFCAZqH#mgFG@>P8B45mqATDL&B-;;7+CQC6FEMP6ApJ*.B-:]#Bl.:'/g*Z#@;]RhDJ()#F<G72F!,[8FCSu:+AH9h+ED%8F`MA2A0>u4+EV:.+EMX5B4W30Bln#2@3B/uDfp)7F(d05,!g*W+Du+A/0Jb;A8,Ur+CT.u+D58'FDPN*ASs%C+D>=/@V&tbARm>7,&)*@AThX*H#IS3+D>2,Bl7Q+Df0,/CghC,+EqaAA7]dnF_i1BBl.EG+poMsATKCH+CehrCh7-\"Dfp.EFD,5.F)Q)@+E(j7E+Ns,Ch4`5BQ##'@;Ka&Dfp.E,'da@+s;)CASrW#Df'&rBjkn#+CT>,+EV:.D'3P)+EV:.GpdWD+D>2,Bl7Q+@3Bc4DId=!Ap%o4FD5T'/d`e%BOQ!1F!,[FDId=!Ap%o@+s:H7FD,f<ARloX@<a=G,%4r%DesQ<AScW7GAhA0ATDC*Cb?hrDIakuF!,R<AKYr*Dffo8+EMXCEc#k?B45mqATAo-DBO\"EBl\\$(DJ()%Ec6/4F!+n3Dfor.+E_`V+E2@4E+*d$DJ()6D]j.5@<*K!E+*d/+EV:.+DbJ-F<GL6+EV:.+ED%(+D>\\8+EM[CF\"AG*+DYk5G9D0LFXM3@+CT)&+D5V,DJ()6D]j+4FED>1+C\\bhCER&'A0>H$C2\\A?GA2/4+Dk[4GA(E,+A!\\kDJs_AG@_n@Bl%T.Anc-n+CT)&+CT.1Bl.]uDKBB*Gp$[C@qg%!DJ()#DIal3ATDX%DII?(AU&0*EbT*&@q@8:$:n_NE+*m1ARmD987`oR@<H3rF<G[=AKYE(A8,Um@q?d,Bln#2@3B3!BlnH.EbTE(+D#h0/d`dhASc'lG%De5ALns?@:X(`F!+n/A0>MrDKK]+D.RT9+s:Q1+ELt*A1SiIFD,6+ALDOADJsW1Bl7Q+E+Np0CijB.@<?''@:F.tF<G[=BlbD8DIkFE$:n_NE+*m1ARlolB45Ll/g+,3DJ<`sF<G72F!,R=D/!m#+Eq78+DG\\0@:OFr@<?'5+B3&lAKYDnFCfJ8FD5T'+D>=/BOPEoA8c?s+EV:2F!,O;Dg*`TDJ<`sF<G\"(FCfJ8DJ<`sF=n\\2Dfd+DBOQ!*FD,5.GAhM4+Dtn+BQPA1@:UKhDL!@AARTIjDJ()*ATD?)@<<W6BOr;tG][t;D/\"*;+E(j7FD5T'/g*GrC`mh5ATD?)G@>P8FD,5.ASu$pATMo8Eb03$FD5i2Df-\\9Afu2/AKYT!DII?(D/X9&DKIEP@<3Q5BOr;aATMs%F`Lo.F<GUB@r#Xd+EM@;GAMOIAoD^6@<,m$Dg#]4+EV:.+C]A*DJLA5Afu20D.P)9+D,b:FD,6,F<G.*B4W2;+CT.u+C\\bhCER%u@;0U3+B3#gF!)ZEBkM+$+s;)<F!,+6De'u4BQ&$+BIk9JBOr;pF_#2tDI[6#G@>P8GB.D>BPD?s+DG^9FD,5.E+*R\"+E(j7BPDN1F(o-\"Cj@.:@;]U.+@p3f+Eh[;@q?cnEc5o9ARmD9<+oig+D>1o+EVNEF*)G2Bl5&8D]i_)@<*K(Bl,I0,#i5iF\"ALXBOr<-@;07'+<ki;@;Kb*+DGm>FD,5.@:F:rCisi2+D#G$/0K%JAKYT!DII?(@q]RmCh[d\"+Co&)Derj(Bl@l?+DG^9GA(]#BHVD1AKZ21Deru-D..0jF*),++EMa<AT/c1AftT(ART[pDf-\\,ARfXqATJu*G][Y;@rs=G<+oue+DbIsBk;?.@;]TuB4Yt&Ch7HpDBNY7+EV:.+E2@>G%G]'Bjkg#-Y[ZM/g:WnAKYN(DfBZ,A0>Q\"F!,XEBk(]sF*),4C`mP4G@beI+A$GnFD,5.F*),4Ci3g*F\"AGB+D,G8+EqaHCh+Z+Dfd+8@<Q3)A79LiA0>AuARTU%BlnD=FD,]5@<=+/,!fg_ATAo8BPDN=+s:Q1+ELt*A1SiIFD,6+AKY].+Du+>BPD?s/g+25Bk/h=7;[!cBl7L'F\"SS2@Vfb%Bl@lA+@0IXDesQ<AKYl/FD,B+B.beh+o";

const mask = [
    "1100110011111100110011",
    "1100110011001100110011",
    "1100110011001100110011",
    "1111110011001100111111",
    "0000110011001100000011",
    "0000110011111100000011"
];

const titleText = ":gn!J+AQis+@^9lDI`"; // "Page Not Found"

const FONT_WEIGHT = 700;
const FONT_FAMILY = '"Courier Prime"';
const LINE_HEIGHT_RATIO = 0.9;
const REFERENCE_FONT_SIZE = 100;
const LAYOUT_WIDTH_LIMIT = 1000000;
const BINARY_SEARCH_STEPS = 24;
const NON_BREAKING_SPACE = "\xa0";
const MASK_HEIGHT = mask.length;
const MASK_WIDTH = mask[0].length;
const HOLE_COUNT = mask.reduce(
    (count, row) => count + row.split("").filter((cell) => cell === "1").length,
    0
);
const REFERENCE_SAMPLE = originalText.slice(0, 256);

const buildFont = (fontSize) => `${FONT_WEIGHT} ${fontSize}px ${FONT_FAMILY}`;

const fillSecretText = (visibleCharCount) => {
    let filledText = "";

    while (filledText.length < visibleCharCount) {
        filledText += originalText;
    }

    return filledText.slice(0, visibleCharCount);
};

const buildRenderedLines = (columns, rows) => {
    const visibleSlots = rows * columns - HOLE_COUNT;
    const filledText = fillSecretText(visibleSlots);
    const startRow = Math.floor((rows - MASK_HEIGHT) / 2);
    const startCol = Math.floor((columns - MASK_WIDTH) / 2);
    const renderedLines = [];
    let textIndex = 0;

    for (let row = 0; row < rows; row++) {
        let line = "";

        for (let col = 0; col < columns; col++) {
            const maskRow = row - startRow;
            const maskCol = col - startCol;
            const isHole =
                maskRow >= 0 &&
                maskRow < MASK_HEIGHT &&
                maskCol >= 0 &&
                maskCol < MASK_WIDTH &&
                mask[maskRow][maskCol] === "1";

            if (isHole) {
                line += NON_BREAKING_SPACE;
                continue;
            }

            line += filledText[textIndex];
            textIndex += 1;
        }

        renderedLines.push(line);
    }

    return renderedLines;
};

const measureAverageCharWidthRatio = () => {
    const prepared = prepareWithSegments(
        REFERENCE_SAMPLE,
        buildFont(REFERENCE_FONT_SIZE),
        { whiteSpace: "pre-wrap" }
    );
    const { lines } = layoutWithLines(
        prepared,
        LAYOUT_WIDTH_LIMIT,
        REFERENCE_FONT_SIZE * LINE_HEIGHT_RATIO
    );
    const measuredWidth = lines[0]?.width ?? 0;

    if (measuredWidth <= 0) {
        return 0.6;
    }

    return measuredWidth / REFERENCE_SAMPLE.length / REFERENCE_FONT_SIZE;
};

const measureMaxLineWidth = (renderedLines, fontSize) => {
    const prepared = prepareWithSegments(
        renderedLines.join("\n"),
        buildFont(fontSize),
        { whiteSpace: "pre-wrap" }
    );
    const { lines } = layoutWithLines(
        prepared,
        LAYOUT_WIDTH_LIMIT,
        fontSize * LINE_HEIGHT_RATIO
    );

    return lines.reduce((maxWidth, line) => Math.max(maxWidth, line.width), 0);
};

const computeTextLayout = (width, height, charWidthRatio) => {
    let low = 1;
    let high = Math.max(width, height);
    let bestLayout = null;

    for (let i = 0; i < BINARY_SEARCH_STEPS; i++) {
        const fontSize = (low + high) / 2;
        const charWidth = fontSize * charWidthRatio;
        const columns = Math.floor(width / charWidth);
        const rows = Math.floor(height / (fontSize * LINE_HEIGHT_RATIO));
        const visibleCharCount = rows * columns - HOLE_COUNT;
        const canRenderMask =
            columns >= MASK_WIDTH &&
            rows >= MASK_HEIGHT &&
            visibleCharCount >= originalText.length;

        if (canRenderMask) {
            bestLayout = { fontSize, columns, rows };
            low = fontSize;
        } else {
            high = fontSize;
        }
    }

    if (bestLayout === null) {
        const fallbackFontSize = Math.max(
            1,
            Math.min(
                width / (MASK_WIDTH * charWidthRatio),
                height / (MASK_HEIGHT * LINE_HEIGHT_RATIO)
            )
        );

        bestLayout = {
            fontSize: fallbackFontSize,
            columns: Math.max(
                MASK_WIDTH,
                Math.floor(width / (fallbackFontSize * charWidthRatio))
            ),
            rows: Math.max(
                MASK_HEIGHT,
                Math.floor(height / (fallbackFontSize * LINE_HEIGHT_RATIO))
            )
        };
    }

    const renderedLines = buildRenderedLines(bestLayout.columns, bestLayout.rows);

    return {
        fontSize: bestLayout.fontSize,
        renderedText: renderedLines.join("\n"),
        textWidth: measureMaxLineWidth(renderedLines, bestLayout.fontSize)
    };
};

const NotFound = () => {
    const containerRef = useRef(null);
    const [charWidthRatio, setCharWidthRatio] = useState(null);
    const [viewport, setViewport] = useState({ width: 0, height: 0 });
    const [textLayout, setTextLayout] = useState({
        fontSize: 0,
        renderedText: "",
        textWidth: 0
    });

    useEffect(() => {
        document.title = titleText;
    }, []);

    useEffect(() => {
        let cancelled = false;

        const measure = () => {
            const nextRatio = measureAverageCharWidthRatio();

            if (cancelled) {
                return;
            }

            startTransition(() => {
                setCharWidthRatio(nextRatio);
            });
        };

        if (document.fonts === undefined) {
            measure();
            return () => {
                cancelled = true;
            };
        }

        Promise.all([
            document.fonts.ready,
            document.fonts.load(buildFont(REFERENCE_FONT_SIZE))
        ])
            .then(measure)
            .catch(measure);

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        const container = containerRef.current;

        if (container === null) {
            return undefined;
        }

        let frameId = 0;

        const updateViewport = (nextWidth, nextHeight) => {
            cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(() => {
                startTransition(() => {
                    setViewport((previousViewport) => {
                        if (
                            previousViewport.width === nextWidth &&
                            previousViewport.height === nextHeight
                        ) {
                            return previousViewport;
                        }

                        return { width: nextWidth, height: nextHeight };
                    });
                });
            });
        };

        const syncViewport = () => {
            updateViewport(container.clientWidth, container.clientHeight);
        };

        syncViewport();

        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", syncViewport);

            return () => {
                cancelAnimationFrame(frameId);
                window.removeEventListener("resize", syncViewport);
            };
        }

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];

            if (entry === undefined) {
                syncViewport();
                return;
            }

            updateViewport(
                Math.floor(entry.contentRect.width),
                Math.floor(entry.contentRect.height)
            );
        });

        observer.observe(container);

        return () => {
            cancelAnimationFrame(frameId);
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (
            charWidthRatio === null ||
            viewport.width <= 0 ||
            viewport.height <= 0
        ) {
            return;
        }

        const nextLayout = computeTextLayout(
            viewport.width,
            viewport.height,
            charWidthRatio
        );

        startTransition(() => {
            setTextLayout(nextLayout);
        });
    }, [charWidthRatio, viewport.height, viewport.width]);

    return (
        <>
            <Helmet>                             {/* You have come to a 404 page where nothing is implemented. Check the URL and try again. */}
                <meta name="description" content={"=`8F*BOQ'q+Cf>,AKZ)5+CQBL0Jjnk@:s-oGA(Q.AKYl/FD,B+B-:o0+DG\\3Ch7HpDKKH#/g*MpARfKuFD,5.<DlL5@;]TuFE2XL@:s\"_DCt"}/>
            </Helmet>
            <Box
                ref={containerRef}
                alignItems="center"
                display="flex"
                h="100vh"
                justifyContent="center"
                overflow="hidden"
                w="100vw"
            >
                <Text
                    as="pre"
                    className="crypt"
                    flexShrink={0}
                    fontSize={`${textLayout.fontSize}px`}
                    fontWeight={FONT_WEIGHT}
                    lineHeight={LINE_HEIGHT_RATIO}
                    m={0}
                    maxW="none"
                    overflow="hidden"
                    whiteSpace="pre"
                    w={textLayout.textWidth > 0 ? `${textLayout.textWidth}px` : undefined}
                >
                    {textLayout.renderedText}
                </Text>
            </Box>
        </>
    );
};

export default NotFound;
